// LimitText Class
import { LimitText } from "../classes/LimitText";

const cardsParagraph = document.querySelectorAll("#blog-cards .card p.card-text");

//console.log(cardsParagraph);
cardsParagraph.forEach( (paragraph) => {
    let limit = 150;
    let inputText = paragraph.innerHTML;
    if ( inputText.length > limit ) {
        let limit_Text_size = new LimitText(inputText, limit);
        paragraph.innerHTML = limit_Text_size.limitOutput;
    }
});

const blogs_list = document.querySelectorAll('#blog-cards .blog');

const blogs_search_form = $('#blog #search-wrapper form');


const blogs_filter_menu = $('#blogs-filter');


// // Show active filter switch case
// function showActiveFilter(activeFilter){
//     $('#blog-cards .blogsList').addClass('active');
// }

// Show active filter switch case (UMBRACO)
function blogActiveFilter(activeFilter){
    switch(activeFilter){
        case '#all':
            $('#blog-cards .blogsListAll').addClass('active');
            break;
        case '#popular':
            $('#blog-cards .blogsListPopular').addClass('active');
            break;
        case '#latest':
            $('#blog-cards .blogsListLatest').addClass('active');
            break;
        default:
            $('#blog-cards .blogsListAll').addClass('active');
            break;
    }
}

// Search for an exact keyword
function searchKeyword(keyword) {
    $('#blog-cards .blog').hide();
    blogs_list.forEach((blog) => {
        const current_blog_name = $(blog).find('.card-title').text().toLowerCase();
        const current_blog_text = $(blog).find('.card-text').text().toLowerCase();
        if(current_blog_name.includes(keyword.toLowerCase()) || current_blog_text.includes(keyword.toLowerCase())){
            $(blog).show();
        }
    });
}


$(function(){

    // ON PAGE LOAD EVENT

    // // Hide all blogs list THEN show only the correct filter according to item 'filter'
    // $('#blog-cards .blogsList').removeClass('active');

    // remove active filter item(1st item 'All')
    blogs_filter_menu.find('.nav-link.active').removeClass('active');

    // Check for session storage item (filter) value
    // If not found activate the first choice
    // Else activate the found item 'filter' value
    if(sessionStorage.getItem('blog-filter') === null){
        // Activate the default filter
        blogs_filter_menu.find('li').eq(0).find('.nav-link').addClass('active');
        // Set item to default order value
        sessionStorage.setItem('blog-filter', blogs_filter_menu.find('li').eq(0).find('.nav-link').attr('href'));
    }else{
        // loop over filter nav items
        for( let i=0; i < blogs_filter_menu.find('li').length; i++ ){
            // Compare to item 'filter'
            if(blogs_filter_menu.find('li').eq(i).find('.nav-link').attr('href') === sessionStorage.getItem('blog-filter')){
                // Activate the corresponding nav item
                blogs_filter_menu.find('li').eq(i).find('.nav-link').addClass('active');
            }
        }
    }

    // Sort according to session storage
    let filterBy = sessionStorage.getItem('blog-filter');
    blogActiveFilter(filterBy);
    
    // EVENT HANDLER
    // Search for keyword form submit handler
    blogs_search_form.on('submit', (e) => {
        e.preventDefault();
        const keyword = blogs_search_form.find('input[name=search-field]').val();
        searchKeyword(keyword)
    });
    
    // EVENT HANDLER
    // On search field input
    blogs_search_form.find('input[type=text]').on('input', (e) => {
        if($(e.currentTarget).val()){
            blogs_search_form.find('button[type=reset]').fadeIn();
        }else{
            blogs_search_form.find('button[type=reset]').fadeOut();
        }
    });

    // EVENT HANDLER
    // Reset search field and unfilter results accordingly
    blogs_search_form.on('reset', (e) => {
        searchKeyword('');
        blogs_search_form.find('button[type=reset]').fadeOut();
    });

    // EVENT HANDLER
    // Change filter selection
    blogs_filter_menu.find('.nav-link').on('click', (e) => {
        e.preventDefault();

        const selected_item = $(e.currentTarget);
        blogs_filter_menu.find('.nav-link').removeClass('active');
        selected_item.addClass('active');

        sessionStorage.setItem('blog-filter', selected_item.attr('href').toLowerCase());
        $('#blog-cards .blogsList').removeClass('active');
        // Show only active filter
        filterBy = sessionStorage.getItem('blog-filter');
        blogActiveFilter(filterBy);
    });
    
});

